import { Modal } from '@tryhackme/thm-ui-components';
import { FeedbackForm } from '../../../feedback-form';
import type { FeedbackModalProps } from '../../congratulations-full-screen.types';
export const FeedbackModal = ({
  isOpen,
  onClose,
  roomCode,
  setIsFeedbackSent
}: FeedbackModalProps) => <Modal open={isOpen} onOpenChange={onClose} data-sentry-element="Modal" data-sentry-component="FeedbackModal" data-sentry-source-file="feedback-modal.tsx">
    <FeedbackForm onClose={onClose} roomCode={roomCode} setIsFeedbackSent={setIsFeedbackSent} data-sentry-element="FeedbackForm" data-sentry-source-file="feedback-modal.tsx" />
  </Modal>;